import ruta3 from 'ruta3';

export default class RouteMatcher {
  constructor(routes) {
    // Initialize route pattern matcher
    const matcher = ruta3();
    routes.forEach(route => matcher.addRoute(route.pattern, route));
    this._matcher = matcher;
  }

  find(path) {
    let route = null;
    try {
      route = this._matcher.match(path);
    } catch (e) {
      throw new Error(
        `Failed to find route definition for path '${path}'. Check routing configuration at src/js/routing/routeConfiguration: ${e}`
      );
    }
    return route.action;
  }
}

function normalizeRoutes(routes) {
  if (Array.isArray(routes)) {
    return routes;
  }

  if (routes !== null && typeof routes === 'object') {
    return Object.entries(routes).map(([pattern, handler]) => ({
      pattern,
      handler,
    }));
  }

  throw new Error(
    'Provided routes must either be an object in the form ' +
      '{ [pattern]: handler }, or an array whose elements are objects in the ' +
      'form { pattern: string, handler: function }.'
  );
}

export function buildRouteMatcher(routes) {
  const routeMatcher = ruta3();

  normalizeRoutes(routes).forEach(({ pattern, handler }) => {
    routeMatcher.addRoute(pattern, handler);
  });

  return routeMatcher;
}
